// Self-contained data for the PSO Accounting Group concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/14_PSO_Accounting_Group
// (research snapshot 2026-08-21). The firm's real web presence is fragmented across multiple
// near-duplicate location domains — this concept deliberately consolidates into one brand, one
// service architecture and one location system, per the dossier's explicit modernization note.
// Reviews are split: only clearly client-oriented reviews are used publicly here; two
// employee-oriented reviews recovered in research are intentionally excluded from this
// client-facing concept rather than risk being read as customer testimonials.
export const SLUG = "pso-accounting-group-concept";

export const BIZ = {
  name: "PSO Accounting Group",
  tagline: "Your Partner in Compliance",
  address: "10th Floor, 6780 Ayala Avenue Building, Makati City",
  serviceAreas: ["Alabang / Muntinlupa", "BGC / Taguig"],
  phone: "+639275080210",
  phoneDisplay: "+63 927 508 0210",
  phoneAlt: "+63 928 767 5210",
  whatsapp: "+63 926 308 9482",
  landline: "(02) 8583 4606",
  email: "sherwin@psoaccountants.com",
  facebook: "https://www.facebook.com/Accountingservicesinmuntinlupa/",
  mapEmbed: "https://www.google.com/maps?q=6780+Ayala+Avenue+Makati+City&output=embed",
};

export const NAV_PAGES = [
  { key: "home", label: "Home", path: "" },
  { key: "about", label: "About", path: "/about" },
  { key: "services", label: "Services", path: "/services" },
  { key: "locations", label: "Locations", path: "/locations" },
  { key: "contact", label: "Contact", path: "/contact" },
];

export const ABOUT = {
  founder: "Sherwin O. Porciuncula, CPA",
  story: "I built PSO Accounting Group from scratch, starting around 2015, with continued education through the Asian Institute of Management. I created the firm to help SMEs record transactions correctly, understand their financial statements, make better decisions, and remain tax compliant.",
  affiliations: "My professional profile lists affiliations with BOA, BIR, CDA and PICPA — confirm current validity directly before relying on any specific accreditation.",
  clients: "We serve sole proprietors, corporations, partnerships and professionals — including agents, doctors, dentists, engineers and lawyers.",
};

export const SERVICE_GROUPS = [
  { title: "Accounting & Bookkeeping", areas: ["Outsourced Accounting & Bookkeeping", "QuickBooks & Accounting-System Setup"] },
  { title: "Tax & Compliance", areas: ["Tax Compliance & BIR Filings", "Ongoing Corporate Compliance"] },
  { title: "Business Registration", areas: ["SEC, DTI, BIR & Local Permits", "Nominee Director Services"] },
  { title: "Audit & Advisory", areas: ["External & Year-End Audit", "Agreed-Upon Procedures", "Management Consultancy"] },
  { title: "Payroll", areas: ["Payroll Processing"] },
];

// Only clearly client-oriented reviews are used — two recovered reviews were employee-oriented
// (about working at PSO, not about being a client) and are deliberately excluded here.
export const CLIENT_REVIEWS = [
  { quote: "PSO understands how the client's business actually operates, rather than merely looking at numbers — dedicated, willing to help and good at problem solving.", author: "Ronaldo Castillo", date: "May 2020", source: "BusinessList" },
  { quote: "Has experienced several accounting firms and considers PSO better — praises attention to questions and concerns, tax preparation and handling of accounting issues.", author: "Bing Laura", date: "May 2020", source: "BusinessList" },
  { quote: "Praises accounting service and staff reliability, specifically mentioning incorporation, accounting and taxation — referred colleagues were also happy with the firm.", author: "Jen Era", date: "May 2020", source: "BusinessList" },
  { quote: "Impressed by accountants who seemed to genuinely care — professionalism, honest dealings and affordability.", author: "Karl James Illustre", date: "April 2020", source: "BusinessList" },
  { quote: "PSO successfully completed the business-registration process within the agreed timeline.", author: "James Chris M.", date: "May 2020", source: "StarOfService" },
  { quote: "All accounting concerns were attended to — the kind of accounting partner she had been looking for.", author: "Mikaela G.", date: "April 2020", source: "StarOfService" },
];

export const REPUTATION = {
  rating: "4.8",
  reviewCountLabel: "6+ client reviews recovered across BusinessList and StarOfService",
};
